import { Button, Modal, Box } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

function AccessControlConfirmModal(props) {
    const { open, onClose, onConfirmYes, loading} =props;
  return (
    <Modal open={open} onClose={onClose}>
      <>
        <Box sx={style}>
          <p>Are you sure you want to update the Role for the selected user(s) ?</p>
          <Box>
            <Button
              disabled={loading}
              id="modal-yes-btn"
              variant="contained"
              onClick={onConfirmYes}
            >
              Yes
            </Button>
            <Button
              disabled={loading}
              id="modal-no-btn"
              variant="contained"
              onClick={onClose}
            >
              No
            </Button>
          </Box>
        </Box>
      </>
    </Modal>
  );
}

export default AccessControlConfirmModal;
